/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import AqaQDEntryForAccounts from '../model/AqaQDEntryForAccounts';
import AqaQDResponse from '../model/AqaQDResponse';
import AqaQdPublishingRequest from '../model/AqaQdPublishingRequest';
import AqaQualityDefinitionUpdateResponse from '../model/AqaQualityDefinitionUpdateResponse';
import AqaResponse from '../model/AqaResponse';
import AvaQdDirectoryResponse from '../model/AvaQdDirectoryResponse';

/**
* AQAQualityDefinitionsMarketController service.
* @module api/AQAQualityDefinitionsMarketControllerApi
* @version v0
*/
export default class AQAQualityDefinitionsMarketControllerApi {

    /**
    * Constructs a new AQAQualityDefinitionsMarketControllerApi. 
    * @alias module:api/AQAQualityDefinitionsMarketControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getListOfAccountsSharedWith operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~getListOfAccountsSharedWithCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaQDEntryForAccounts{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of Accounts that a QD is shared with
     * @param {String} qdId 
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~getListOfAccountsSharedWithCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getListOfAccountsSharedWith(qdId, callback) {
      
      let postBody = null;
      // verify the required parameter 'qdId' is set
      if (qdId === undefined || qdId === null) {
        throw new Error("Missing the required parameter 'qdId' when calling getListOfAccountsSharedWith");
      }

      let pathParams = {
        'qdId': qdId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaQDEntryForAccounts;

      return this.apiClient.callApi(
        '/api/v1/qd/accounts/{qdId}/shared', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getQualityDefinitionFromMarket operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~getQualityDefinitionFromMarketCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaQDResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a quality definition from market
     * @param {String} qdId 
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~getQualityDefinitionFromMarketCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getQualityDefinitionFromMarket(qdId, callback) {
      
      let postBody = null;
      // verify the required parameter 'qdId' is set
      if (qdId === undefined || qdId === null) {
        throw new Error("Missing the required parameter 'qdId' when calling getQualityDefinitionFromMarket");
      }

      let pathParams = {
        'qdId': qdId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaQDResponse;

      return this.apiClient.callApi(
        '/api/v1/qd/read/{qdId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the importQualityDefinitionFromMarket operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~importQualityDefinitionFromMarketCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaQualityDefinitionUpdateResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Selects a market Quality Definition bundle and returns id and compatible sources
     * @param {String} qdId 
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~importQualityDefinitionFromMarketCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    importQualityDefinitionFromMarket(qdId, callback) {
      
      let postBody = null;
      // verify the required parameter 'qdId' is set
      if (qdId === undefined || qdId === null) {
        throw new Error("Missing the required parameter 'qdId' when calling importQualityDefinitionFromMarket");
      }

      let pathParams = {
        'qdId': qdId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaQualityDefinitionUpdateResponse;

      return this.apiClient.callApi(
        '/api/v1/qd/acquire/{qdId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the publishQualityDefinition operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~publishQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Publishes an AQD
     * @param {module:model/AqaQdPublishingRequest} body 
     * @param {String} sourceId 
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~publishQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    publishQualityDefinition(body, sourceId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling publishQualityDefinition");
      }
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling publishQualityDefinition");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/qd/{sourceId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the qdDirectory operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~qdDirectoryCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AvaQdDirectoryResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns all the AQDs this account has access to
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~qdDirectoryCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    qdDirectory(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AvaQdDirectoryResponse;

      return this.apiClient.callApi(
        '/api/v1/qd/directory', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the republishQualityDefinition operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~republishQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates an AQD. This takes a source id, the previous AQD will be lost.
     * @param {String} sourceId 
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~republishQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    republishQualityDefinition(sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling republishQualityDefinition");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/qd/source/{sourceId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the unpublishQualityDefinition operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~unpublishQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Unpublishes an AQD
     * @param {String} qdId 
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~unpublishQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    unpublishQualityDefinition(qdId, callback) {
      
      let postBody = null;
      // verify the required parameter 'qdId' is set
      if (qdId === undefined || qdId === null) {
        throw new Error("Missing the required parameter 'qdId' when calling unpublishQualityDefinition");
      }

      let pathParams = {
        'qdId': qdId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/qd/{qdId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateQualityDefinitionFriendlyAccountIds operation.
     * @callback moduleapi/AQAQualityDefinitionsMarketControllerApi~updateQualityDefinitionFriendlyAccountIdsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the accounts an AQD is available to
     * @param {module:model/AqaQdPublishingRequest} body 
     * @param {String} qdId 
     * @param {module:api/AQAQualityDefinitionsMarketControllerApi~updateQualityDefinitionFriendlyAccountIdsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateQualityDefinitionFriendlyAccountIds(body, qdId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateQualityDefinitionFriendlyAccountIds");
      }
      // verify the required parameter 'qdId' is set
      if (qdId === undefined || qdId === null) {
        throw new Error("Missing the required parameter 'qdId' when calling updateQualityDefinitionFriendlyAccountIds");
      }

      let pathParams = {
        'qdId': qdId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/qd/accounts/{qdId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}